import React, { Component } from 'react';
import { centimetersToInches } from 'src/utils/conversion';
import get from 'src/utils/get';
import ResultPresentation from './components/ResultPresentation';
import FootIcon from './components/FootIcon';
import s from './SizeSelector.scss';

class SizeSelector extends Component {

    constructor(props) {
        super(props);
        this.state = {
            faultyInput: false,
            searchValue: '',
            unit: 'cm',
            result: {
                above: false,
                closest: false,
                below: false,
            },
        };
    }

    searchSizes = (needle) => {
        const sizes = get(this.props, 'content.sizes', []);

        if (sizes.length < 1) return false;

        return sizes.reduce((a, b) => {
        const aCM = get(a, 'size.cm', 0);
        const bCM = get(b, 'size.cm', 0);
        const aDiff = Math.abs(aCM - needle);
        const bDiff = Math.abs(bCM - needle);

        if (aDiff === bDiff) return aCM > bCM ? a : b;

        return bDiff < aDiff ? b : a;
        });
    };

    sortSizes = () => {
        const sizes = get(this.props, 'content.sizes', []);

        if (sizes.length < 1) return false;

        return sizes.sort((a, b) => {
        const aCm = parseFloat(get(a, 'size.cm', Infinity));
        const bCm = parseFloat(get(b, 'size.cm', Infinity));
        if (aCm < bCm) return -1;
        if (aCm > bCm) return 1;
        return 0;
        });
    };

    handleSubmit = (e) => {
        const { searchValue, unit } = this.state;

        if (this.isValidInput(searchValue)) {
        const convertedValue = unit === 'in' ? centimetersToInches(searchValue, true) : parseFloat(searchValue);
        const result = this.searchSizes(convertedValue);
        const sizes = this.sortSizes();
        const filteredResult = get(result, 'size', false);
        const resultIndex = sizes.indexOf(result);
        const closestAbove = get(sizes, `${resultIndex + 1}.size`, false);
        const closestBelow = get(sizes, `${resultIndex - 1}.size`, false);

        if (filteredResult) {
            this.setState({
                result: {
                    above: closestAbove,
                    closest: filteredResult,
                    below: closestBelow,
                },
            });
        }
        }
        e.preventDefault();
    };

    handleChange = (e) => {
        const value = e.target.value.replace(/,/g, '.');
        this.setState({ unit: e.target.name, searchValue: value, faultyInput: !this.isValidInput(value) });
    };

    handleUnitChange = (unit = 'cm') => {
        this.setState({ unit, searchValue: '', result: { above: false, closest: false, below: false } });
    }

    isValidInput = (str) => !str || (typeof str === 'string' && !str.match(/^([^0-9])|([^0-9.]|\.(?=.*\.))/g));

    render() {
        const { content } = this.props;
        const { searchValue, result, unit, faultyInput } = this.state;
        const { closest, above, below } = result;

        return (
        <div>

            <h3 style={{ marginBottom: '24px' }}>{content.title}</h3>

            <div className={s.informationBox}>
                <div className={s.textWrapper}>
                    <p>{'The most accurate method to select the correct size is to refer to your skate size.'}</p>
                    <p>{'But if you don’t know your size, enter your foot length below and we’ll help you out.'}</p>
                </div>
                <FootIcon className={s.footIcon} />
            </div>

            <p style={{ margin: '16px 16px 10px 16px', fontWeight: '400', fontSize: '14px' }}>
                {'Enter foot length'}
            </p>

            <form className={s.form} onSubmit={this.handleSubmit}>

                {unit === 'in' && (
                    <label htmlFor="in">
                        {!faultyInput && <span>Inches</span>}
                        {faultyInput && <span className={s.error}>{'Please enter a correct format'}</span>}
                        <input name="in" type="text" onChange={this.handleChange} value={unit === 'in' && searchValue} className={faultyInput ? s.error : ''}/>
                        <button type="button" onClick={() => this.handleUnitChange('cm')}>{'Search with centimeters'}</button>
                    </label>
                )}

                {unit === 'cm' && (
                    <label htmlFor="cm">
                        {!faultyInput && <span>{'Centimeters'}</span>}
                        {faultyInput && <span className={s.error}>{'Please enter a correct format'}</span>}
                        <input name="cm" type="text" onChange={this.handleChange} value={unit === 'cm' && searchValue} className={faultyInput ? s.error : ''}/>
                        <button type="button" onClick={() => this.handleUnitChange('in')}>{'Search with inches'}</button>
                    </label>
                )}

                <input disabled={faultyInput || !searchValue} type="submit" value="SHOW SIZE" />

            </form>

            <p style={{ fontSize: '14px', marginBottom: '24px', fontWeight: '400' }}>
                {(closest || below || above) ? 'You would fit for these sizes:' : 'Type in your measurements above and sizes will be shown below:'}
            </p>

            <ResultPresentation closestSize={closest} downSize={below} upSize={above} unit={unit} className={s.resultPresentation} />

        </div>
        );
    }
    }

export default SizeSelector;
